<script setup lang="ts">
import { unixSecondsToLocalizedDateTimeString } from '@/utils'
import { computed } from 'vue'
import { useWindowSize } from '@/composables/useWindowSize'
import { Calendar } from 'lucide-vue-next'
import { HierarchicAplosFileViewModel } from '../models/HierarchicAplosFileViewModel';

const props = defineProps<{
  record: HierarchicAplosFileViewModel
  index?: number
  selectable?: boolean
  onCellClick?: (record: any, e?: Event) => void
}>()

const { isMediumTierOrLess } = useWindowSize()

const formattedDate = computed(() =>
  props.record?.createdUtcTs ? unixSecondsToLocalizedDateTimeString(props.record.createdUtcTs) : 'N/A'
)

function handleClick(e?: Event) {
  if (props.selectable && props.onCellClick) {
    props.onCellClick(props.record, e)
  }
}
</script>

<template>
  <!-- add centering classes when compact mode is active -->
  <div :class="{ 'cursor-pointer': selectable, 'flex items-center justify-center': isMediumTierOrLess }" @click="handleClick">
    <!-- Show compact icon+tooltip on small screens, otherwise show full text -->
    <template v-if="isMediumTierOrLess">
      <a-tooltip :title="formattedDate">
        <Calendar class="size-5" />
      </a-tooltip>
    </template>
    <template v-else>
      {{ props.record.createdUtcTs ? unixSecondsToLocalizedDateTimeString(props.record.createdUtcTs) : 'N/A' }}
    </template>
  </div>
</template>
